import scrollToElement from './scrollToElement';

export function scrollToFormFirstError(form) {
    if (form && form.getElementsByClassName('is-invalid').length) {
        scrollToElement(
            form.getElementsByClassName('is-invalid')[0].offsetParent
        );
    }
}
